import { AwsConfig, ApolloConfig } from 'src/types';

let hostURL = 'http://localhost:3000/';

if (typeof window !== 'undefined') hostURL = `${window.location.origin}/`;

const {
  REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID,
  REACT_APP_AWS_COGNITO_REGION,
  REACT_APP_AWS_COGNITO_USER_POOL_ID,
  REACT_APP_AWS_COGNITO_APP_CLIENT,
  REACT_APP_AWS_COGNITO_DOMAIN,
  REACT_APP_AWS_APPSYNC_DEV_GRAPHQL_ENDPOINT,
  REACT_APP_AWS_APPSYNC_BETA_GRAPHQL_ENDPOINT,
  REACT_APP_AWS_APPSYNC_PROD_GRAPHQL_ENDPOINT,
  REACT_APP_AZURE_PROVIDER_NAME,
  REACT_APP_AWS_STORAGE_BUCKET,
} = process.env;

export const customProviderName = REACT_APP_AZURE_PROVIDER_NAME;

const awsConfig: AwsConfig = {
  Auth: {
    Cognito: {
      identityPoolId: REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID || '',
      userPoolId: REACT_APP_AWS_COGNITO_USER_POOL_ID || '',
      userPoolClientId: REACT_APP_AWS_COGNITO_APP_CLIENT || '',
      loginWith: {
        oauth: {
          domain: REACT_APP_AWS_COGNITO_DOMAIN || '',
          scopes: [
            'email',
            'openid',
            'aws.cognito.signin.user.admin',
            'profile',
          ],
          redirectSignIn: [hostURL],
          redirectSignOut: [hostURL],
          responseType: 'code', // REFRESH token only generated with 'code'
          providers: REACT_APP_AZURE_PROVIDER_NAME
            ? [{ custom: REACT_APP_AZURE_PROVIDER_NAME }]
            : undefined,
        },
      },
    },
  },
  Storage: {
    S3: {
      bucket: REACT_APP_AWS_STORAGE_BUCKET,
      region: REACT_APP_AWS_COGNITO_REGION,
    },
  },
};

export const apolloConfig: ApolloConfig = {
  devGraphqlEndpoint: REACT_APP_AWS_APPSYNC_DEV_GRAPHQL_ENDPOINT,
  betaGraphqlEndpoint: REACT_APP_AWS_APPSYNC_BETA_GRAPHQL_ENDPOINT,
  prodGraphqlEndpoint: REACT_APP_AWS_APPSYNC_PROD_GRAPHQL_ENDPOINT,
};

export default awsConfig;
